// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 21/08/2025
const EndOfDayActionTypes = {
	/** ***************** GET ALL COLLECTION DETAILS START *********************** */
	GET_ALL_COLLECTION_DETAILS_START: 'get_all_collection_details_start',
	GET_ALL_COLLECTION_DETAILS_SUCCESS: 'get_all_collection_details_success',
	GET_ALL_COLLECTION_DETAILS_FAILURE: 'get_all_collection_details_failure',
	GET_ALL_COLLECTION_DETAILS_RESPONSE_RESET: 'get_all_collection_details_response_reset',
	GET_ALL_COLLECTION_DETAILS_RESPONSE_CHANGED: 'get_all_collection_details_response_changed',
	/** ***************** GET ALL COLLECTION DETAILS END *********************** */

	/** ***************** GET BRANCH EOD WALLET DETAILS START *********************** */
	GET_BRANCH_EOD_WALLET_DETAILS_START: 'get_branch_eod_wallet_details_start',
	GET_BRANCH_EOD_WALLET_DETAILS_SUCCESS: 'get_branch_eod_wallet_details_success',
	GET_BRANCH_EOD_WALLET_DETAILS_FAILURE: 'get_branch_eod_wallet_details_failure',
	GET_BRANCH_EOD_WALLET_DETAILS_RESPONSE_RESET: 'get_branch_eod_wallet_details_response_reset',
	GET_BRANCH_EOD_WALLET_DETAILS_RESPONSE_CHANGED:
		'get_branch_eod_wallet_details_response_changed',
	/** ***************** GET BRANCH EOD WALLET DETAILS END *********************** */

	/** ***************** GET BRANCH EOD THRIFT DETAILS START *********************** */
	GET_BRANCH_EOD_THRIFT_DETAILS_START: 'get_branch_eod_thrift_details_start',
	GET_BRANCH_EOD_THRIFT_DETAILS_SUCCESS: 'get_branch_eod_thrift_details_success',
	GET_BRANCH_EOD_THRIFT_DETAILS_FAILURE: 'get_branch_eod_thrift_details_failure',
	GET_BRANCH_EOD_THRIFT_DETAILS_RESPONSE_RESET: 'get_branch_eod_thrift_details_response_reset',
	GET_BRANCH_EOD_THRIFT_DETAILS_RESPONSE_CHANGED:
		'get_branch_eod_thrift_details_response_changed',
	/** ***************** GET BRANCH EOD THRIFT DETAILS END *********************** */

	/** ***************** GET BRANCH EOD SAVINGS DETAILS START *********************** */
	GET_BRANCH_EOD_SAVINGS_DETAILS_START: 'get_branch_eod_thrift_details_start',
	GET_BRANCH_EOD_SAVINGS_DETAILS_SUCCESS: 'get_branch_eod_thrift_details_success',
	GET_BRANCH_EOD_SAVINGS_DETAILS_FAILURE: 'get_branch_eod_thrift_details_failure',
	GET_BRANCH_EOD_SAVINGS_DETAILS_RESPONSE_RESET: 'get_branch_eod_thrift_details_response_reset',
	GET_BRANCH_EOD_SAVINGS_DETAILS_RESPONSE_CHANGED:
		'get_branch_eod_savings_details_response_changed',
	/** ***************** GET BRANCH EOD SAVINGS DETAILS END *********************** */

	/** ***************** GET BRANCH EOD YET TO COLLECT ARREAR DETAILS START *********************** */
	GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_START:
		'get_branch_eod_yettocollect_arrear_details_start',
	GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_SUCCESS:
		'get_branch_eod_yettocollect_arrear_details_success',
	GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_FAILURE:
		'get_branch_eod_yettocollect_arrear_details_failure',
	GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_RESPONSE_RESET:
		'get_branch_eod_yettocollect_arrear_details_response_reset',
	GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_RESPONSE_CHANGED:
		'get_branch_eod_yettocollect_arrear_details_response_changed',
	/** ***************** GET BRANCH EOD YET TO COLLECT ARREAR DETAILS START *********************** */

	/** ***************** GET DEMAND COLLECTION TOTAL DETAILS START *********************** */
	GET_DEMAND_COLLECTION_TOTAL_DETAILS_START: 'get_demand_collection_total_details_start',
	GET_DEMAND_COLLECTION_TOTAL_DETAILS_SUCCESS: 'get_demand_collection_total_details_success',
	GET_DEMAND_COLLECTION_TOTAL_DETAILS_FAILURE: 'get_demand_collection_total_details_failure',
	GET_DEMAND_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET:
		'get_demand_collection_total_details_response_reset',
	GET_DEMAND_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
		'get_demand_collection_total_details_response_changed',
	/** ***************** GET DEMAND COLLECTION TOTAL DETAILS END *********************** */

	/** ***************** GET ADVANCE COLLECTION TOTAL DETAILS START *********************** */
	GET_ADVANCE_COLLECTION_TOTAL_DETAILS_START: 'get_advance_collection_total_details_start',
	GET_ADVANCE_COLLECTION_TOTAL_DETAILS_SUCCESS: 'get_advance_collection_total_details_success',
	GET_ADVANCE_COLLECTION_TOTAL_DETAILS_FAILURE: 'get_advance_collection_total_details_failure',
	GET_ADVANCE_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET:
		'get_advance_collection_total_details_response_reset',
	GET_ADVANCE_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
		'get_advance_collection_total_details_response_changed',
	/** ***************** GET ADVANCE COLLECTION TOTAL DETAILS END *********************** */

	/** ***************** GET ARREAR COLLECTION TOTAL DETAILS START *********************** */
	GET_ARREAR_COLLECTION_TOTAL_DETAILS_START: 'get_arrear_collection_total_details_start',
	GET_ARREAR_COLLECTION_TOTAL_DETAILS_SUCCESS: 'get_arrear_collection_total_details_success',
	GET_ARREAR_COLLECTION_TOTAL_DETAILS_FAILURE: 'get_arrear_collection_total_details_failure',
	GET_ARREAR_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET:
		'get_arrear_collection_total_details_response_reset',
	GET_ARREAR_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
		'get_arrear_collection_total_details_response_changed',
	/** ***************** GET ARREAR COLLECTION TOTAL DETAILS END *********************** */

	/** ***************** GET WALLET COLLECTION TOTAL DETAILS START *********************** */
	GET_WALLET_COLLECTION_TOTAL_DETAILS_START: 'get_wallet_collection_total_details_start',
	GET_WALLET_COLLECTION_TOTAL_DETAILS_SUCCESS: 'get_wallet_collection_total_details_success',
	GET_WALLET_COLLECTION_TOTAL_DETAILS_FAILURE: 'get_wallet_collection_total_details_failure',
	GET_WALLET_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET:
		'get_wallet_collection_total_details_response_reset',
	GET_WALLET_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
		'get_wallet_collection_total_details_response_changed',
	/** ***************** GET WALLET COLLECTION TOTAL DETAILS END *********************** */

	GET_ACCOUNT_DAY_BOOK_REPORT_START: 'GET_ACCOUNT_DAY_BOOK_REPORT_START',
	GET_ACCOUNT_DAY_BOOK_REPORT_SUCCESS: 'GET_ACCOUNT_DAY_BOOK_REPORT_SUCCESS',
	GET_ACCOUNT_DAY_BOOK_REPORT_FAILURE: 'GET_ACCOUNT_DAY_BOOK_REPORT_FAILURE',
	GET_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET: 'GET_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET',
	GET_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED: 'GET_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED',

	/** ***************** GET PRECLOSE COLLECTION TOTAL DETAILS START *********************** */
	GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_START: 'get_preclose_collection_total_details_start',
	GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_SUCCESS: 'get_preclose_collection_total_details_success',
	GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_FAILURE: 'get_preclose_collection_total_details_failure',
	GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET:
		'get_preclose_collection_total_details_response_reset',
	GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
		'get_preclose_collection_total_details_response_changed',
	/** ***************** GET PRECLOSE COLLECTION TOTAL DETAILS END *********************** */

	/** ***************** GET LOAN ADVANCE USED TOTAL DETAILS START *********************** */
	GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_START: 'get_loan_advance_used_total_details_start',
	GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_SUCCESS: 'get_loan_advance_used_total_details_success',
	GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_FAILURE: 'get_loan_advance_used_total_details_failure',
	GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_RESPONSE_RESET:
		'get_loan_advance_used_total_details_response_reset',
	GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_RESPONSE_CHANGED:
		'get_loan_advance_used_total_details_response_changed',
	/** ***************** GET LOAN ADVANCE USED TOTAL DETAILS END *********************** */

	/** ***************** GET CLOSE LOAN LIST DETAILS START *********************** */
	GET_CLOSE_LOAN_LIST_DETAILS_START: 'get_close_loan_list_details_start',
	GET_CLOSE_LOAN_LIST_DETAILS_SUCCESS: 'get_close_loan_list_details_success',
	GET_CLOSE_LOAN_LIST_DETAILS_FAILURE: 'get_close_loan_list_details_failure',
	GET_CLOSE_LOAN_LIST_DETAILS_RESPONSE_RESET: 'get_close_loan_list_details_response_reset',
	GET_CLOSE_LOAN_LIST_DETAILS_RESPONSE_CHANGED: 'get_close_loan_list_details_response_changed',
	/** ***************** GET CLOSE LOAN LIST DETAILS END *********************** */

	/** ***************** GET BRANCH EOD DETAILS START *********************** */
	GET_BRANCH_EOD_DETAILS_START: 'get_branch_eod_details_start',
	GET_BRANCH_EOD_DETAILS_SUCCESS: 'get_branch_eod_details_success',
	GET_BRANCH_EOD_DETAILS_FAILURE: 'get_branch_eod_details_failure',
	GET_BRANCH_EOD_DETAILS_RESPONSE_RESET: 'get_branch_eod_details_response_reset',
	GET_BRANCH_EOD_DETAILS_RESPONSE_CHANGED: 'get_branch_eod_details_response_changed',
	/** ***************** GET BRANCH EOD DETAILS END *********************** */

	/** ***************** GET PREVIOUS DAY BANK ACCOUNT DAY BOOK REPORT START *********************** */
	GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_START:
		'get_previous_day_bank_account_day_book_report_start',
	GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_SUCCESS:
		'get_previous_day_bank_account_day_book_report_success',
	GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_FAILURE:
		'get_previous_day_bank_account_day_book_report_failure',
	GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET:
		'get_previous_day_bank_account_day_book_report_response_reset',
	GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED:
		'get_previous_day_bank_account_day_book_report_response_changed',
	/** ***************** GET PREVIOUS DAY BANK ACCOUNT DAY BOOK REPORT END *********************** */

	/** ***************** GET BANK ACCOUNT DAY BOOK REPORT START *********************** */
	GET_BANK_ACCOUNT_DAY_BOOK_REPORT_START: 'get_bank_account_day_book_report_start',
	GET_BANK_ACCOUNT_DAY_BOOK_REPORT_SUCCESS: 'get_bank_account_day_book_report_success',
	GET_BANK_ACCOUNT_DAY_BOOK_REPORT_FAILURE: 'get_bank_account_day_book_report_failure',
	GET_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET:
		'get_bank_account_day_book_report_response_reset',
	GET_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED:
		'get_bank_account_day_book_report_response_changed',
	/** ***************** GET BANK ACCOUNT DAY BOOK REPORT END *********************** */

	/** ***************** GET PREVIOUS DAY CASH ACCOUNT DAY BOOK REPORT START *********************** */
	GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_START:
		'get_previous_day_cash_account_day_book_report_start',
	GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_SUCCESS:
		'get_previous_day_cash_account_day_book_report_success',
	GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_FAILURE:
		'get_previous_day_cash_account_day_book_report_failure',
	GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET:
		'get_previous_day_cash_account_day_book_report_response_reset',
	GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED:
		'get_previous_day_cash_account_day_book_report_response_changed',
	/** ***************** GET PREVIOUS DAY CASH ACCOUNT DAY BOOK REPORT END *********************** */

	/** ***************** GET CASH ACCOUNT DAY BOOK REPORT START *********************** */
	GET_CASH_ACCOUNT_DAY_BOOK_REPORT_START: 'get_cash_account_day_book_report_start',
	GET_CASH_ACCOUNT_DAY_BOOK_REPORT_SUCCESS: 'get_cash_account_day_book_report_success',
	GET_CASH_ACCOUNT_DAY_BOOK_REPORT_FAILURE: 'get_cash_account_day_book_report_failure',
	GET_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET:
		'get_cash_account_day_book_report_response_reset',
	GET_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED:
		'get_cash_account_day_book_report_response_changed',
	/** ***************** GET CASH ACCOUNT DAY BOOK REPORT END *********************** */

	/** ***************** GET PRECLOSE COLLECTION DETAILS START *********************** */
	GET_PRECLOSE_COLLECTION_DETAILS_START: 'get_preclose_collection_details_start',
	GET_PRECLOSE_COLLECTION_DETAILS_SUCCESS: 'get_preclose_collection_details_success',
	GET_PRECLOSE_COLLECTION_DETAILS_FAILURE: 'get_preclose_collection_details_failure',
	GET_PRECLOSE_COLLECTION_DETAILS_RESPONSE_RESET:
		'get_preclose_collection_details_response_reset',
	GET_PRECLOSE_COLLECTION_DETAILS_RESPONSE_CHANGED:
		'get_preclose_collection_details_response_changed',
	/** ***************** GET PRECLOSE COLLECTION DETAILS END *********************** */

	/** ***************** GET ADVANCE COLLECTION DETAILS START *********************** */
	GET_ADVANCE_COLLECTION_DETAILS_START: 'get_advance_collection_details_start',
	GET_ADVANCE_COLLECTION_DETAILS_SUCCESS: 'get_advance_collection_details_success',
	GET_ADVANCE_COLLECTION_DETAILS_FAILURE: 'get_advance_collection_details_failure',
	GET_ADVANCE_COLLECTION_DETAILS_RESPONSE_RESET: 'get_advance_collection_details_response_reset',
	GET_ADVANCE_COLLECTION_DETAILS_RESPONSE_CHANGED:
		'get_advance_collection_details_response_changed',
	/** ***************** GET ADVANCE COLLECTION DETAILS END *********************** */

	/** ***************** GET ARREAR COLLECTION DETAILS START *********************** */
	GET_ARREAR_COLLECTION_DETAILS_START: 'get_arrear_collection_details_start',
	GET_ARREAR_COLLECTION_DETAILS_SUCCESS: 'get_arrear_collection_details_success',
	GET_ARREAR_COLLECTION_DETAILS_FAILURE: 'get_arrear_collection_details_failure',
	GET_ARREAR_COLLECTION_DETAILS_RESPONSE_RESET: 'get_arrear_collection_details_response_reset',
	GET_ARREAR_COLLECTION_DETAILS_RESPONSE_CHANGED:
		'get_arrear_collection_details_response_changed',
	/** ***************** GET ARREAR COLLECTION DETAILS END *********************** */

	/** ***************** GET VOUCHER APPROVED DETAILS START *********************** */
	GET_VOUCHER_APPROVED_DETAILS_START: 'get_voucher_approved_details_start',
	GET_VOUCHER_APPROVED_DETAILS_SUCCESS: 'get_voucher_approved_details_success',
	GET_VOUCHER_APPROVED_DETAILS_FAILURE: 'get_voucher_approved_details_failure',
	GET_VOUCHER_APPROVED_DETAILS_RESPONSE_RESET: 'get_voucher_approved_details_response_reset',
	GET_VOUCHER_APPROVED_DETAILS_RESPONSE_CHANGED: 'get_voucher_approved_details_response_changed',
	/** ***************** GET VOUCHER APPROVED DETAILS END *********************** */

	/** ***************** GET SUBMIT EOD DETAILS START *********************** */
	GET_SUBMIT_EOD_DETAILS_START: 'get_eod_submit_details_start',
	GET_SUBMIT_EOD_DETAILS_SUCCESS: 'get_eod_submit_details_success',
	GET_SUBMIT_EOD_DETAILS_FAILURE: 'get_eod_submit_details_failure',
	GET_SUBMIT_EOD_DETAILS_RESPONSE_RESET: 'get_eod_submit_details_response_reset',
	GET_SUBMIT_EOD_DETAILS_RESPONSE_CHANGED: 'get_eod_submit_details_response_changed',
	/** ***************** GET SUBMIT EOD DETAILS END *********************** */

	/** ***************** GET REVERT EOD DETAILS START *********************** */
	GET_REVERT_EOD_DETAILS_START: 'get_eod_revert_details_start',
	GET_REVERT_EOD_DETAILS_SUCCESS: 'get_eod_revert_details_success',
	GET_REVERT_EOD_DETAILS_FAILURE: 'get_eod_revert_details_failure',
	GET_REVERT_EOD_DETAILS_RESPONSE_RESET: 'get_eod_revert_details_response_reset',
	GET_REVERT_EOD_DETAILS_RESPONSE_CHANGED: 'get_eod_revert_details_response_changed',
	/** ***************** GET REVERT EOD DETAILS END *********************** */

	/** ***************** GET EOD SAVINGS COLLECTION DETAILS START *********************** */
	GET_EOD_SAVINGS_COLLECTION_DETAILS_START: 'get_eod_savings_collection_details_start',
	GET_EOD_SAVINGS_COLLECTION_DETAILS_SUCCESS: 'get_eod_savings_collection_details_success',
	GET_EOD_SAVINGS_COLLECTION_DETAILS_FAILURE: 'get_eod_savings_collection_details_failure',
	GET_EOD_SAVINGS_COLLECTION_DETAILS_RESPONSE_RESET:
		'get_eod_savings_collection_details_response_reset',
	GET_EOD_SAVINGS_COLLECTION_DETAILS_RESPONSE_CHANGED:
		'get_eod_savings_collection_details_response_changed',
	/** ***************** GET EOD SAVINGS COLLECTION DETAILS END *********************** */

	/** ***************** GET EOD GOLD COLLECTION DETAILS START *********************** */
	GET_EOD_GOLD_COLLECTION_DETAILS_START: 'get_eod_gold_collection_details_start',
	GET_EOD_GOLD_COLLECTION_DETAILS_SUCCESS: 'get_eod_gold_collection_details_success',
	GET_EOD_GOLD_COLLECTION_DETAILS_FAILURE: 'get_eod_gold_collection_details_failure',
	GET_EOD_GOLD_COLLECTION_DETAILS_RESPONSE_RESET:
		'get_eod_gold_collection_details_response_reset',
	GET_EOD_GOLD_COLLECTION_DETAILS_RESPONSE_CHANGED:
		'get_eod_gold_collection_details_response_changed',
	/** ***************** GET EOD GOLD COLLECTION DETAILS END *********************** */

	/** ***************** GET EOD STAFF TRAVEL DETAILS START *********************** */
	GET_EOD_STAFF_TRAVEL_DETAILS_START: 'get_eod_staff_travel_details_start',
	GET_EOD_STAFF_TRAVEL_DETAILS_SUCCESS: 'get_eod_staff_travel_details_success',
	GET_EOD_STAFF_TRAVEL_DETAILS_FAILURE: 'get_eod_staff_travel_details_failure',
	GET_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_RESET: 'get_eod_staff_travel_details_response_reset',
	GET_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_CHANGED: 'get_eod_staff_travel_details_response_changed',
	/** ***************** GET EOD STAFF TRAVEL DETAILS END *********************** */

	/** ***************** SUBMIT EOD STAFF TRAVEL DETAILS START *********************** */
	SUBMIT_EOD_STAFF_TRAVEL_DETAILS_START: 'submit_eod_staff_travel_details_start',
	SUBMIT_EOD_STAFF_TRAVEL_DETAILS_SUCCESS: 'submit_eod_staff_travel_details_success',
	SUBMIT_EOD_STAFF_TRAVEL_DETAILS_FAILURE: 'submit_eod_staff_travel_details_failure',
	SUBMIT_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_RESET:
		'submit_eod_staff_travel_details_response_reset',
	SUBMIT_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_CHANGED:
		'submit_eod_staff_travel_details_response_changed',
	/** ***************** SUBMIT EOD STAFF TRAVEL DETAILS END *********************** */
};
export default EndOfDayActionTypes;
